<template>
  <div>
    <div class="row">
      <div class="col-12 pl-0">
        <div class="p-3">
          <form @submit.prevent="updateUser">
            <div class="row align-items-center">
              <div class="col-12">
                <div class="row justify-content-between">
                  <div class="col-auto">
                    <h5 class="e-text-red">
                      {{
                        auditorData
                          ? [
                            auditorData.honorifics,
                            auditorData.first_name,
                            auditorData.middle_name,
                            auditorData.last_name,
                            auditorData.suffix
                          ].filter(Boolean).join(' ')
                          : ''
                      }}
                    </h5>
                  </div>
                  <div class="col-auto" v-if="isAllowed('audit-team.auditors.edit')">
                    <button class="e-btn e-btn-outlined-red e-text-red e-text-white-hover mr-1" type="button" v-if="toEdit" @click="cancelEdit">
                      <font-awesome-icon icon="ban" class="e-text-red"/>
                      Cancel
                    </button>
                    <button class="e-btn e-btn-outlined-orange e-text-orange e-text-white-hover" v-else type="button" @click="editAuditor">
                      <font-awesome-icon icon="pen" class="e-text-orange"/>
                      Edit Auditor
                    </button>
                    <button class="e-btn e-btn-green e-text-white ml-1" type="submit" v-if="toEdit">
                      <font-awesome-icon icon="save"/>
                      Save
                    </button>
                  </div>
                </div>
              </div>
              <div class="col-lg-10">
                <div class="row align-items-center no-gutters my-1">
                  <div class="col-12">
                    <h6 class="mb-0 font-weight-bold e-text-red">Auditor's Information</h6>
                  </div>
                </div>
                <div class="row align-items-center no-gutters mb-1">
                  <div class="col-lg-2">
                    <label class="font-weight-bolder mb-0">Honorifics:</label>
                  </div>
                  <div class="col-lg-10" v-if="toEdit">
                    <input type="text" v-model="auditorEditedData.honorifics" name="honorifics" class="form-control form-control-sm">
                  </div>
                  <div class="col-lg-10" v-else>
                    {{ auditorData ? auditorData.honorifics : '' }}
                  </div>
                </div>
                <div class="row align-items-center no-gutters mb-1">
                  <div class="col-lg-2">
                    <label class="font-weight-bolder mb-0"><sub v-if="toEdit" class="lead e-text-red font-weight-bold">*</sub> First Name:</label>
                  </div>
                  <div class="col-lg-10" v-if="toEdit">
                    <input type="text" v-model="auditorEditedData.first_name" name="first_name" class="form-control form-control-sm">
                  </div>
                  <div class="col-lg-10" v-else>
                    {{ auditorData ? auditorData.first_name : '' }}
                  </div>
                </div>
                <div class="row align-items-center no-gutters mb-1">
                  <div class="col-lg-2">
                    <label class="font-weight-bolder mb-0"><sub v-if="toEdit" class="lead e-text-red font-weight-bold">*</sub> Last Name:</label>
                  </div>
                  <div class="col-lg-10" v-if="toEdit">
                    <input type="text" v-model="auditorEditedData.last_name" name="last_name" class="form-control form-control-sm">
                  </div>
                  <div class="col-lg-10" v-else>
                    {{ auditorData ? auditorData.last_name : '' }}
                  </div>
                </div>
                <div class="row align-items-center no-gutters mb-1">
                  <div class="col-lg-2">
                    <label class="font-weight-bolder mb-0">Middle Name:</label>
                  </div>
                  <div class="col-lg-10" v-if="toEdit">
                    <input type="text" v-model="auditorEditedData.middle_name" name="middle_name" class="form-control form-control-sm">
                  </div>
                  <div class="col-lg-10" v-else>
                    {{ auditorData ? auditorData.middle_name : '' }}
                  </div>
                </div>
                <div class="row align-items-center no-gutters mb-1">
                  <div class="col-lg-2">
                    <label class="font-weight-bolder mb-0">Suffix:</label>
                  </div>
                  <div class="col-lg-10" v-if="toEdit">
                    <input type="text" v-model="auditorEditedData.suffix" name="suffix" class="form-control form-control-sm">
                  </div>
                  <div class="col-lg-10" v-else>
                    {{ auditorData ? auditorData.suffix : '' }}
                  </div>
                </div>
                <div class="row align-items-center no-gutters mb-1">
                  <div class="col-lg-2">
                    <label class="font-weight-bolder mb-0">Contact Number:</label>
                  </div>
                  <div class="col-lg-10" v-if="toEdit">
                    <input type="text" v-model="auditorEditedData.contact_number" name="contact_number" class="form-control form-control-sm">
                  </div>
                  <div class="col-lg-10" v-else>
                    {{ auditorData.contact_number ?? '' }}
                  </div>
                </div>
                <div class="row align-items-center no-gutters mb-1">
                  <div class="col-lg-2">
                    <label class="font-weight-bolder mb-0"><sub v-if="toEdit" class="lead e-text-red font-weight-bold">*</sub> Email:</label>
                  </div>
                  <div class="col-lg-10" v-if="toEdit">
                    <input type="text" v-model="auditorEditedData.email" name="email" class="form-control form-control-sm">
                  </div>
                  <div class="col-lg-10" v-else>
                    {{ auditorData ? auditorData.email : '' }}
                  </div>
                </div>
                <div class="row align-items-center no-gutters mb-1">
                  <div class="col-lg-2">
                    <label class="font-weight-bolder mb-0">Signature:</label>
                  </div>
                  <div class="col-lg-10" v-if="toEdit">
                    <div class="dropdown dropright" v-if="auditorEditedData.signature_url">
                      <img
                        :src = "auditorData.signature_url"
                        style="width: 400px !important; cursor:pointer"
                        id="actionDropdown"
                        aria-expanded="false"
                        aria-haspopup="true"
                        data-toggle="dropdown"
                        alt="Attachment Thumbnail"
                      >
                      <div aria-labelledby="actionDropdown" class="dropdown-menu py-0">
                        <button class="dropdown-item text-secondary font-weight-bolder"
                                @click.prevent="viewSignature"
                        >
                          <font-awesome-icon icon="eye"/>
                          View
                        </button>
                        <button class="dropdown-item text-secondary font-weight-bolder text-danger"
                                @click.prevent="removeSignature"
                        >
                          <font-awesome-icon icon="trash" class="force-danger-all"/>
                          Delete
                        </button>
                      </div>
                    </div>
                    <template v-else>
                      <button class="e-btn e-btn-green" type="button" @click="$refs.auditor_signature.click()">{{ signatureImageSrc ? 'Change' : 'Add' }}</button>
                      <input style="visibility: hidden; margin-left: -25px" type="file" class="form-control-sm" ref="auditor_signature" accept="image/png" @change="setSignature">
                      <button type="button" class="btn btn-danger mr-1" v-if="signatureImageSrc && croppedSignature === false" @click="cancelCropping">
                        <font-awesome-icon icon="times" class="e-text-white"/>
                      </button>
                      <button type="button" class="btn btn-success" v-if="signatureImageSrc && croppedSignature === false" @click="cropSignature">
                        <font-awesome-icon icon="check" class="e-text-white"/>
                      </button>
                      <template v-if="croppedSignature">
                        <div v-if="signatureImageSrc"
                             class="border rounded-md mt-1"
                             style="width: 400px">
                          <img alt="" :src = "signatureImageSrc" style="width: 400px !important;">
                        </div>
                      </template>
                      <template v-else>
                        <div v-if="signatureImageSrc"
                             class="border rounded-md mt-1"
                             style="width: 400px">
                          <Cropper
                            ref="cropper"
                            :src="signatureImageSrc"
                            :stencil-props="{
                          minCropBoxWidth: 600,
                          maxCropBoxWidth: 600,
                          minCropBoxHeight: 100,
                          maxCropBoxHeight: 100
                        }"
                            class="h-full w-full"
                          />
                        </div>
                      </template>

                    </template>

                  </div>
                  <div class="col-lg-10" v-else>
                    <div class="dropdown dropright" v-if="auditorData.signature_url">
                      <img
                        :src = "auditorData.signature_url"
                        style="width: 400px !important; cursor:pointer"
                        id="actionDropdown"
                        aria-expanded="false"
                        aria-haspopup="true"
                        data-toggle="dropdown"
                        alt="Attachment Thumbnail"
                      >
                      <div aria-labelledby="actionDropdown" class="dropdown-menu py-0">
                        <button class="dropdown-item text-secondary font-weight-bolder"
                                @click.prevent="viewSignature"
                        >
                          <font-awesome-icon icon="eye"/>
                          View
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row align-items-center no-gutters mb-1">
                  <div class="col-lg-2">
                    <label class="font-weight-bolder mb-0"><sub v-if="toEdit" class="lead e-text-red font-weight-bold">*</sub> Department:</label>
                  </div>
                  <div class="col-lg-10" v-if="toEdit">
                    <select class="form-control form-control-sm text-uppercase" name="management_office_id" v-model="auditorEditedData.auditor_department_id">
                      <option :value="null">—— Select Department ——</option>
                      <option v-for="department in auditor_departments" :key="department.id" :value="department.id">
                        {{ department.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-10" v-else>
                    {{ (auditorData && auditorData.department) ? auditorData.department.name : '' }}
                  </div>
                </div>

                <div class="row align-items-center no-gutters mb-1">
                  <div class="col-lg-2">
                    <label class="font-weight-bolder mb-0"><sub v-if="toEdit" class="lead e-text-red font-weight-bold">*</sub> Position:</label>
                  </div>
                  <div class="col-lg-10" v-if="toEdit">
                    <select class="form-control form-control-sm text-uppercase" name="management_office_id" v-model="auditorEditedData.auditor_position_id">
                      <option :value="null">—— Select Position ——</option>
                      <option v-for="position in auditor_positions" :key="position.id" :value="position.id">
                        {{ position.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-10" v-else>
                    {{ (auditorData && auditorData.position) ? auditorData.position.name : '' }}
                  </div>
                </div>
                <div class="row align-items-center no-gutters mb-1">
                  <div class="col-lg-2">
                    <label class="font-weight-bolder mb-0"><sub v-if="toEdit" class="lead e-text-red font-weight-bold">*</sub> Management Office:</label>
                  </div>
                  <div class="col-lg-10" v-if="toEdit">
                    <select class="form-control form-control-sm text-uppercase" name="management_office_id" v-model="auditorEditedData.management_office_id">
                      <option :value="null">—— Select Management Office ——</option>
                      <option v-for="mngmntOffice in mngmntOfficeKeys" :key="mngmntOffice.id" :value="mngmntOffice.id">
                        {{ mngmntOffice.name }}
                      </option>
                    </select>
                  </div>
                  <div class="col-lg-10" v-else>
                    {{ (auditorData && auditorData.management_office) ? auditorData.management_office.name : '' }}
                  </div>
                </div>
                <div class="row align-items-center no-gutters mb-1">
                  <div class="col-lg-2">
                    <label class="font-weight-bolder mb-0">Designated Person (D.P.)</label>
                  </div>
                  <div class="col-lg-10" v-if="toEdit">
                    <select class="form-control form-control-sm text-uppercase" name="management_office_id" v-model="auditorEditedData.is_designated_person" @change="changeDesignatedPerson">
                      <option :value="1">Yes</option>
                      <option :value="0">No</option>
                    </select>
                  </div>
                  <div class="col-lg-10" v-else>
                    {{ auditorData?.is_designated_person === 1 ? 'Yes' : 'No' }}
                  </div>
                </div>
                <template v-if="toEdit">
                  <template v-if="auditorEditedData?.is_designated_person === 1">
                    <div class="row align-items-center no-gutters mb-1">
                      <div class="col-lg-2">
                        <label class="font-weight-bolder mb-0">(D.P.) Branch Office:</label>
                      </div>
                      <div class="col-lg-10" v-if="auditorEditedData.is_designated_person === 1">
                        <select class="form-control form-control-sm text-uppercase" name="management_office_id" v-model="auditorEditedData.dp_branch_office_id">
                          <option :value="null">—— Select Branch Office ——</option>
                          <option v-for="branchOffice in mngmntOfficeKeys" :key="branchOffice.id" :value="branchOffice.id">
                            {{ branchOffice.name }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div class="row align-items-center no-gutters mb-1">
                      <div class="col-lg-2">
                        <label class="font-weight-bolder mb-0">(D.P.) Audit Types</label>
                      </div>
                      <div class="col-lg-10">
                        <div class="form-group row no-gutters mb-1">
                          <div class="form-check form-check-inline">
                            <input class="form-check-input checkbox-input" type="checkbox" value="sms" id="audit_type_sms" v-model="auditorEditedData.audit_types">
                            <label for="audit_type_sms" class="font-weight-bold col-m-3 col-form-label no-select cursor-pointer">SMS</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input checkbox-input" type="checkbox" value="isps" id="audit_type_isps" v-model="auditorEditedData.audit_types">
                            <label for="audit_type_isps" class="font-weight-bold col-m-3 col-form-label no-select cursor-pointer">ISPS</label>
                          </div>
                          <div class="form-check form-check-inline">
                            <input class="form-check-input checkbox-input" type="checkbox" value="cyber" id="audit_type_cyber" v-model="auditorEditedData.audit_types">
                            <label for="audit_type_cyber" class="font-weight-bold col-m-3 col-form-label no-select cursor-pointer">CYBER</label>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="row align-items-center no-gutters mb-1">
                      <div class="col-lg-2">
                        <label class="font-weight-bolder mb-0">(D.P.) Certificates:</label>
                      </div>

                      <div class="col-lg-10">

                        <button
                          type="button"
                          class="btn btn-sm btn-success mb-2"
                          @click="triggerDpCertificateUpload"
                        >
                          Add Attachments
                        </button>

                        <input
                          type="file"
                          multiple
                          class="d-none"
                          ref="dp_certificate"
                          accept="application/pdf"
                          @change="setDpCertificates"
                        >

                        <span class="ml-2" v-if="dpCertificates.length">
      {{ dpCertificates.length }}
      file{{ dpCertificates.length === 1 ? '' : 's' }}
    </span>


                        <div class="row mt-2" v-if="dpCertificates.length">

                          <div
                            v-for="(certificate,index) in dpCertificates"
                            :key="index"
                            class="col-12 col-md-6 mb-3"
                          >

                            <div class="p-2 border rounded position-relative">

                              <div class="d-flex align-items-center">
                                <font-awesome-icon
                                  icon="file-pdf"
                                  size="2x"
                                  class="force-danger-all mr-2"
                                />

                                <span class="font-weight-bold">
              {{ truncateText(certificate.file_name,30) }}
            </span>
                              </div>


                              <button
                                type="button"
                                class="btn btn-sm btn-secondary position-absolute"
                                style="top:0;right:0"
                                @click.prevent="removeDpCertificate(index)"
                              >
                                X
                              </button>


                              <div class="form-group row no-gutters mt-2">
                                <label class="font-weight-bolder col-sm-4 col-form-label">
                                  Issued Date
                                </label>

                                <div class="col-sm-8">
                                  <input
                                    type="date"
                                    class="form-control form-control-sm"
                                    v-model="certificate.issued_date"
                                  >
                                </div>
                              </div>


                              <div class="form-group row no-gutters">
                                <label class="font-weight-bolder col-sm-4 col-form-label">
                                  Expiry Date
                                </label>

                                <div class="col-sm-8">
                                  <input
                                    type="date"
                                    class="form-control form-control-sm"
                                    v-model="certificate.expiration_date"
                                  >
                                </div>
                              </div>

                            </div>

                          </div>

                        </div>

                      </div>
                    </div>

                  </template>

                </template>
                <template v-else>
                  <template v-if="auditorData?.is_designated_person === 1">
                    <div class="row align-items-center no-gutters mb-1">
                      <div class="col-lg-2">
                        <label class="font-weight-bolder mb-0">(D.P.) Branch Office:</label>
                      </div>
                      <div class="col-lg-10">
                        {{ (auditorData && auditorData?.dp_branch_office) ? auditorData?.dp_branch_office?.name : '' }}
                      </div>
                    </div>
                    <div class="row align-items-center no-gutters mb-1">
                      <div class="col-lg-2">
                        <label class="font-weight-bolder mb-0">(D.P.) Audit Types:</label>
                      </div>
                      <div class="col-lg-10 text-uppercase">
                        {{ (auditorData && auditorData?.audit_types) ? auditorData?.audit_types.join(', ') : '' }}
                      </div>
                    </div>

                  </template>
                </template>
                <div class="row align-items-center no-gutters mb-1">
                  <div class="col-lg-2">
                    <label class="font-weight-bolder mb-0">External Auditor?:</label>
                  </div>
                  <div class="col-lg-10" v-if="toEdit">
                    <select class="form-control form-control-sm text-uppercase" name="is_internal_of_external_auditor" v-model="auditorEditedData.is_internal_of_external_auditor">
                      <option :value="true">Yes</option>
                      <option :value="false">No</option>
                    </select>
                  </div>
                  <div class="col-lg-10" v-else>
                    {{ auditorData?.is_internal_of_external_auditor === true ? 'Yes' : 'No' }}
                  </div>
                </div>

                <div class="row align-items-center no-gutters mb-1">
                  <div class="col-lg-2">
                    <label class="font-weight-bolder mb-0">Is Auditor Lead?</label>
                  </div>
                  <div class="col-lg-10" v-if="toEdit">
                    <select class="form-control form-control-sm text-uppercase" name="is_lead" v-model="auditorEditedData.is_lead" @change="changeIsLead">
                      <option :value="true">Yes</option>
                      <option :value="false">No</option>
                    </select>
                  </div>
                  <div class="col-lg-10" v-else>
                    {{ auditorData?.is_lead === true ? 'Yes' : 'No' }}
                  </div>
                </div>

                <template v-if="toEdit">
                  <div class="row align-items-center no-gutters mb-1" v-if="auditorEditedData.is_lead">
                    <div class="col-lg-2">
                      <label class="font-weight-bolder mb-0">Lead Types</label>
                    </div>
                    <div class="col-lg-10">
                      <div class="form-group row no-gutters mb-1">
                        <div class="form-check form-check-inline">
                          <input class="form-check-input checkbox-input" type="checkbox" value="sms" id="lead_type_sms" v-model="auditorEditedData.lead_types">
                          <label for="lead_type_sms" class="font-weight-bold col-m-3 col-form-label no-select cursor-pointer">SMS</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input checkbox-input" type="checkbox" value="isps" id="lead_type_isps" v-model="auditorEditedData.lead_types">
                          <label for="lead_type_isps" class="font-weight-bold col-m-3 col-form-label no-select cursor-pointer">ISPS</label>
                        </div>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input checkbox-input" type="checkbox" value="cyber" id="lead_type_cyber" v-model="auditorEditedData.lead_types">
                          <label for="lead_type_cyber" class="font-weight-bold col-m-3 col-form-label no-select cursor-pointer">CYBER</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div class="row align-items-center no-gutters mb-1">
                    <div class="col-lg-2">
                      <label class="font-weight-bolder mb-0">Lead Types:</label>
                    </div>
                    <div class="col-lg-10 text-uppercase">
                      {{ (auditorData && auditorData?.lead_types) ? auditorData?.lead_types.join(', ') : '' }}
                    </div>
                  </div>
                </template>




                <div class="row align-items-center no-gutters mb-1">
                  <div class="col-lg-2">
                    <label class="font-weight-bolder mb-0">Status:</label>
                  </div>
                  <div class="col-lg-10" v-if="toEdit">
                    <select class="form-control form-control-sm text-uppercase" name="is_active" v-model="auditorEditedData.is_active">
                      <option :value="1">Active</option>
                      <option :value="0">Inactive</option>
                    </select>
                  </div>
                  <div class="col-lg-10" v-else>
    <span
      class="badge font-weight-bold"
      :class="{
        'badge-success': auditorData?.is_active === 1,
        'badge-secondary': auditorData?.is_active === 0
      }"
    >
      {{ auditorData?.is_active === 1 ? 'Active' : 'Inactive' }}
    </span>
                  </div>
                </div>

                <div class="row align-items-center no-gutters my-3">
                  <div class="col-12">
                    <h6 class="mb-0 font-weight-bold e-text-red">Auditor Certificates</h6>
                  </div>
                </div>

                <div class="row align-items-center no-gutters mb-1">
                  <div class="col-lg-8">
                    <template v-if="!toEdit">
                      <div
                        v-if="auditorData.certificates &&
  auditorData.certificates.some(cert => cert.is_designated_person_certificate === 0)"
                        class="row"
                      >
                        <div
                          v-for="certificate in auditorData.certificates.filter(cert => cert.is_designated_person_certificate === 0)"
                          :key="certificate.id"
                          class="col-12 col-md-6 mb-3"
                        >
                          <div class="p-2 border rounded">
                            <div class="d-flex align-items-center">
                              <font-awesome-icon icon="file-pdf" size="2x" class="force-danger-all mr-2" @click.prevent="viewCertificate(certificate.path_url)"/>
                              <span class="font-weight-bold" :title="certificate.file_name">{{ truncateText(certificate.file_name, 30) }}</span>
                            </div>
                            <div class="mt-2 ml-4">
                              <strong>Issued Date:</strong> {{ certificate.issued_date ? certificate.issued_date : 'N/A' }}
                              <br>
                              <strong>Expiry Date:</strong> {{ certificate.expiration_date ? certificate.expiration_date : 'N/A' }}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-else>
                        No certificates found.
                      </div>
                    </template>

                    <template v-else>
                      <div class="mb-3 d-flex align-items-center">
                        <button type="button" class="btn btn-sm btn-success" @click="triggerFileUpload">
                          Add Attachments
                        </button>
                        <input type="file" multiple class="d-none" id="certificate-file-upload" ref="auditor_certificate" accept="application/pdf" @change="setAuditorCertificate">
                        <span
                          class="ml-2"
                          v-if="auditorEditedData.certificates &&
  auditorEditedData.certificates.filter(cert => cert.is_designated_person_certificate === 0).length > 0"
                        >
  {{ auditorEditedData.certificates.filter(cert => cert.is_designated_person_certificate === 0).length }}
  file{{ auditorEditedData.certificates.filter(cert => cert.is_designated_person_certificate === 0).length === 1 ? '' : 's' }}
</span>
                      </div>
                      <div
                        v-if="auditorEditedData.certificates &&
  auditorEditedData.certificates.some(cert => cert.is_designated_person_certificate === 0)"
                        class="row"
                      >
                        <div
                          v-for="(certificate, index) in auditorEditedData.certificates.filter(cert => cert.is_designated_person_certificate === 0)"
                          :key="certificate.id || `new-${index}`"
                          class="col-12 col-md-6 mb-3"
                        >
                          <div class="p-2 border rounded position-relative">
                            <div class="d-flex align-items-center">
                              <p class="font-weight-bold">
                                <font-awesome-icon icon="file-pdf" size="2x" class="force-danger-all mr-2" @click.prevent="viewCertificate(certificate.path_url)"/>
                                <span :title="certificate.file_name">
            {{ truncateText(certificate.file_name, 30) }}
          </span>
                              </p>
                            </div>
                            <button
                              type="button"
                              class="btn btn-sm btn-secondary position-absolute"
                              style="top: 0; right: 0; margin-top: 0px; margin-right: 0px;"
                              @click.prevent="removeCertificate(certificate)"
                            >
                              X
                            </button>
                            <div class="form-group row no-gutters mb-1">
                              <label :for="`issued_date-${index}`" class="font-weight-bolder col-sm-4 col-form-label">Issued Date</label>
                              <div class="col-sm-8">
                                <input type="date" :id="`issued_date-${index}`" class="form-control form-control-sm" v-model="certificate.issued_date">
                              </div>
                            </div>
                            <div class="form-group row no-gutters mb-1">
                              <label :for="`expiration_date-${index}`" class="font-weight-bolder col-sm-4 col-form-label">Expiry Date</label>
                              <div class="col-sm-8">
                                <input type="date" :id="`expiration_date-${index}`" class="form-control form-control-sm" v-model="certificate.expiration_date">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppLoading from "@/components/elements/AppLoading";
import {mapActions, mapGetters} from "vuex";
import {AlertService} from "@/services/AlertService";
import {permissionMixin} from "@/mixins/permissionMixins";
import MultiSelectCustom from "@/components/MultiSelectCustom.vue";
import AuditorMixin from "@/mixins/AuditorMixin";
import DateMixin from "@/mixins/DateMixin";
import ImageCapture from "@/components/common/avatar/ImageCapture.vue";
import ImageUpload from "@/components/common/avatar/ImageUpload.vue";

export default {
  name: "AuditorGeneralInfo",
  mixins:[permissionMixin, DateMixin, AuditorMixin],
  data () {
    return {
      staffIcon: require('@/assets/staff_icon.png'),
      loading: false,
      auditorEditedData : null,
      toEdit: false,
      toImgUpload: false,
      toImgCapture: false,
      showCertificateField : false,
      certificatesToDelete : [],
      signatureImageSrc : null,
      croppedSignature : false,
      dpCertificates: [],
    }
  },

  methods: {
    ...mapActions(['getMngmtOfficeKeys', 'getAuditorData', 'getAuditorList', 'deleteAuditorCertificate', 'updateAuditor']),
    triggerDpCertificateUpload() {
      this.$refs.dp_certificate.click();
    },
    setDpCertificates() {
      const files = this.$refs.dp_certificate.files;
      for (let i = 0; i < files.length; i++) {

        this.dpCertificates.push({
          file: files[i],
          file_name: files[i].name,
          issued_date: null,
          expiration_date: null,
          is_designated_person_certificate: 1
        });
      }
    },
    removeDpCertificate(index) {
      this.dpCertificates.splice(index,1);
    },
    truncateText(text, length) {
      if (text.length > length) {
        return text.substring(0, length) + '...';
      }
      return text;
    },
    triggerFileUpload() {
      this.$refs.auditor_certificate.click();
    },
    viewSignature() {
      const link = document.createElement('a');
      link.setAttribute('href', this.auditorData.signature_url);
      link.setAttribute('target', '_blank');
      document.body.appendChild(link);
      link.click();
    },
    cancelEdit() {
      this.toEdit = false;
      this.auditorEditedData = Object.assign({}, this.auditorData);
      this.certificatesToDelete = [];
      this.croppedSignature = false;
      this.signatureImageSrc = null;
      this.dpCertificates = [];
    },
    editAuditor() {
      this.auditorEditedData = Object.assign({}, this.auditorData);
      this.auditorEditedData.is_active = this.auditorData.is_active === 1 ? 1 : 0;
      this.auditorEditedData.certificates = Array.isArray(this.auditorData.certificates) ? this.auditorData.certificates.map(cert => ({...cert})) : [];
      this.toEdit = true;
    },
    async updateUser() {
      if (!this.toEdit) return;

      if (this.signatureImageSrc && this.croppedSignature === false) {
        return AlertService.errorAlert('Signature needs to be cropped before saving.', 'SAVING AUDITOR INFO');
      }

      let formData = new FormData();
      let param = Object.assign({}, this.auditorEditedData);

      if (param.email === '') {
        param.email = null;
      }
      if (param.contact_number === '') {
        param.contact_number = null;
      }

      const newCertificates = param.certificates.filter(cert => cert.file);
      newCertificates.forEach((cert, index) => {
        formData.append(`certificate_files[${index}]`, cert.file);
        formData.append(`certificate_issued_dates[${index}]`, cert.issued_date || '');
        formData.append(`certificate_expiration_dates[${index}]`, cert.expiration_date || '');
        formData.append(`certificate_is_designated_person_certificate[${index}]`, 0);
      });

      this.dpCertificates.forEach((cert,index)=>{
        formData.append(`dp_certificate_files[${index}]`, cert.file);
        formData.append(`dp_certificate_issued_dates[${index}]`, cert.issued_date || '');
        formData.append(`dp_certificate_expiration_dates[${index}]`, cert.expiration_date || '');
        formData.append(`dp_certificate_is_designated_person_certificate[${index}]`, 1
        );
      });

      const existingCertificates = param.certificates.filter(cert => cert.id && !cert.file);
      existingCertificates.forEach((cert, index) => {
        formData.append(`existing_certificate_ids[${index}]`, cert.id);
        formData.append(`existing_certificate_issued_dates[${index}]`, cert.issued_date || '');
        formData.append(`existing_certificate_expiration_dates[${index}]`, cert.expiration_date || '');

      });

      for (const key in param) {
        if (key !== 'certificates' && key !== 'profile_photo' && key !== 'is_internal_of_external_auditor' && key !== 'is_lead' && key !== 'email' && key !== 'is_active') {
          formData.append(key, param[key] === null ? '' : param[key]);
        }
        if (key === 'audit_types' || key === 'lead_types') {
          param[key].forEach((item, item_key) => {
            formData.append(key + `[${item_key}]`, item);
          })
        }
      }

      formData.append('is_lead', param.is_lead ? 1 : 0);
      formData.append('is_internal_of_external_auditor', param.is_internal_of_external_auditor ? 1 : 0);
      formData.append('is_active', param.is_active ? 1 : 0);

      if (param.email !== null) {
        formData.append('email', param.email);
      }
      if (param.contact_number !== null) {
        formData.append('contact_number', param.contact_number);
      }

      for (const cert of this.certificatesToDelete) {
        await this.deleteAuditorCertificate(cert.id);
      }

      let updateResponse = await this.updateAuditor({
        id: this.auditorEditedData.id,
        formData: formData
      });

      if (updateResponse.result === false) {

        if (updateResponse.duplicate) {

          const proceed = await AlertService.confirmUpdateAlert(
            updateResponse.message + '\n Do you want to continue?',
            'Yes, Continue'
          );

          if (!proceed) {
            return;
          }

          formData.set('force_update', 1);

          updateResponse = await this.updateAuditor({
            id: this.auditorEditedData.id,
            formData: formData
          });

          if (updateResponse.result === false) {
            return AlertService.errorAlert(updateResponse.message, 'UPDATING OF AUDITOR');
          }

        } else {
          return AlertService.errorAlert(updateResponse.message, 'UPDATING OF AUDITOR');
        }
      }

      this.certificatesToDelete = [];

      await this.getAuditorData({
        auditor_id: this.$route.params.id
      });
      this.toEdit = false;
      this.signatureImageSrc = null;
      this.croppedSignature = false;
      this.dpCertificates = [];
      AlertService.successAlert(updateResponse.message, 'UPDATING OF AUDITOR');
    },

    setSignature() {
      if (this.$refs.auditor_signature.files[0]) {
        const file = this.$refs.auditor_signature.files[0];
        if (file && file.type !== "image/png") {
          AlertService.errorAlert('Only PNG files are allowed.', 'IMAGE SIGNATURE SELECTION');
          this.signatureImageSrc = null;
          return;
        }

        console.log(URL.createObjectURL(this.$refs.auditor_signature.files[0]));
        this.signatureImageSrc = URL.createObjectURL(this.$refs.auditor_signature.files[0]);
      } else {
        this.signatureImageSrc = null;
      }
      this.croppedSignature = false;
    },
    cancelCropping() {
      this.signatureImageSrc = null;
      this.croppedSignature = false;
    },
    cropSignature() {
      const {canvas,} = this.$refs.cropper.getResult();
      this.signatureImageSrc = canvas.toDataURL();
      this.croppedSignature = true;

      canvas.toBlob((blob) => {
        this.auditorEditedData.signature = blob;
      }, 'image/png')
    },
    setAuditorCertificate() {
      const files = this.$refs.auditor_certificate.files;
      for (let i = 0; i < files.length; i++) {
        this.auditorEditedData.certificates.push({
          file: files[i],
          file_name: files[i].name,
          issued_date: null,
          expiration_date: null,
          is_designated_person_certificate: 0
        });
      }
    },
    removeSignature() {
      this.auditorEditedData.signature_url = null;
    },
    removeCertificate(certificate) {
      if (certificate.id) {
        this.certificatesToDelete.push(certificate);
      }

      const index = this.auditorEditedData.certificates.findIndex(
        cert => cert.id === certificate.id
      );

      if (index !== -1) {
        this.auditorEditedData.certificates.splice(index, 1);
      }
    },
    viewCertificate(url) {
      if (url) {
        window.open(url, '_blank');
      }
    },
    changeDesignatedPerson() {
      this.auditorEditedData.dp_branch_office_id = null;
      this.auditorEditedData.audit_types = [];
    },
    changeIsLead() {
      this.auditorEditedData.lead_types = [];
    }
  },

  components: {
    ImageUpload,
    ImageCapture,
    MultiSelectCustom,
    'loading': AppLoading,
    Cropper: () => Promise.all([
      import(/* webpackChunkName: "vue-advanced-cropper" */ 'vue-advanced-cropper'),
      import(/* webpackChunkName: "vue-advanced-cropper" */ 'vue-advanced-cropper/dist/style.css'),
    ]).then(([m]) => m.Cropper),
  },
  computed: {
    ...mapGetters(['mngmntOfficeKeys', 'auditorData', 'leadAuditors', 'nonLeadAuditors']),
  },
  mounted() {
    $('#main_content').css({
      marginLeft: '15px',
      marginRight: '10px'
    });
  },
}
</script>

<style scoped lang="scss">
.nav > li {
  margin: .5rem 0;
  padding: .5rem;
  border-radius: 5px;

  &:hover, &:hover * {
    background-color: white;
    color: #d3313c;
  }
}

.e-btn-grp > li {
  list-style: none;
  font-size: 13px;
  padding: 4px;
  border-radius: 3px;
  color: #d3313c;
  cursor: pointer;

  &:hover {
    background-color: #fbeaec;
  }

  * {
    color: #d3313c;
  }
}

table tbody td {
  vertical-align: middle !important;
}

table tbody td label {
  margin-bottom: 0 !important;
}

#ModelNav {
  padding: 0;

  li > a {
    padding: .5rem 1rem;
    color: #435464;
  }

  li:hover a {
    border-bottom: 2px solid #d3313c;
    color: #d3313c;
  }
}

.router-link-active {
  border-bottom: 2px solid #d3313c;
  color: #d3313c;

  * {
    color: #d3313c;
  }
}
</style>
